import { getRouter } from '@app/router';
import GlobalsStoreModule from '@app/store/modules/GlobalsStoreModule';
import IRawContact from '@app/types/base/IRawContact';
import IThankYouSlideData from '@app/types/data/slides/IThankYouSlideData';
import ISlideMaster from '@app/types/presentations/master/ISlideMaster';
import IPresentationSettings from '@app/types/presentations/presentation/IPresentationSettings';
import { Transformation as CloudinaryTransformation } from 'cloudinary-core';
import VueRouter from 'vue-router';
import { getModule as getStoreModule } from 'vuex-module-decorators';
import PresentationStoreModule from '../../store/modules/PresentationStoreModule';
import IContactPerson from '../../types/data/base/IContactPerson';
import AbstractSlideTransform from './AbstractSlideTransform';

/**
 * Transform for 019-ThankYouSlide
 */
export default class ThankYouSlideTransform extends AbstractSlideTransform {
	public viewComponent: string = 'ThankYouSlide';

	public async transform(
		slide: ISlideMaster,
		presentationSettings: IPresentationSettings
	): Promise<IThankYouSlideData> {
		const globalsStore: GlobalsStoreModule = getStoreModule(GlobalsStoreModule);
		const presentationStore: PresentationStoreModule = getStoreModule(PresentationStoreModule);

		const contacts: IContactPerson[] = (
			presentationSettings.contactIds
				.map((contactId): IRawContact | undefined =>
					globalsStore.contacts.find((contact: IRawContact): boolean => contact.id === contactId)
				)
				.filter((contact: IRawContact | undefined): boolean => !!contact) as IRawContact[]
		).map((contact: IRawContact): IContactPerson => {
			// We need to extract this transformation because prettier formats it in a wrong way
			const transformation: CloudinaryTransformation.Options = {
				width: 240,
				height: 240,
				crop: 'fill'
			};

			return {
				...contact,
				image: this.transformImageAsset(contact.image, transformation)
			};
		});

		const router: VueRouter = await getRouter();

		const presentationShareUrl: string = `${window.location.origin}${
			router.resolve({ name: 'share', params: { id: presentationStore.presentation.id } }).href
		}`;

		return {
			id: slide.id,
			label: slide.fields.label || slide.fields.headline,
			thumbnail: this.extractThumbnail(slide.fields.headline, slide, 'image'),
			headline: slide.fields.headline,
			copy: this.transformRichtext(slide.fields.copy, presentationSettings),
			image: this.transformImageAsset(slide.fields.image?.fields.asset ?? this.getFallbackImage(), {
				width: 5000,
				height: 5000,
				crop: 'limit'
			}),
			link: {
				label: presentationShareUrl.replace(/^https?:\/\//, ''),
				url: presentationShareUrl
			},
			contacts
		};
	}
}
